import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
// import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import {
  campaignSystem,
  campaignSystemUpdate,
} from "../../../data/ApiEndpoints";
import { toast } from "react-toastify";
import { commonUpdate } from "../../../redux/reducers/putApiSlice";
import SelectDropdown from "../../components-react/SelectDropdown";
import { campaignTypes, panelTypes } from "../../common-data/DropdowData";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";

const CampaignForm = ({ userInfoData, closeModal, callFunction, rowData }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.common);

  const iniFormValues = [
    {
      campaignId: rowData?.campaign_id || "",
      campaignName: rowData?.campaign_name?.replace(/_/g, " ") || "",
      panelType: rowData?.panel_type
        ? {
            value: rowData?.panel_type || "",
            label: rowData?.panel_type === "panel_1" ? "Main(P2P)" : "IVR",
          }
        : "",
      campaignType: rowData?.campaign_type
        ? {
            value: rowData?.campaign_type || "",
            label: rowData?.campaign_type === "1" ? "P2P" : "IVR",
          }
        : "",
      wpTemConnected: rowData?.wp_template_connected || "",
      wpTemMissed: rowData?.wp_template_missed || "",
      agentMissed: rowData?.wp_template_connected_agent_missed || "",
      // userMissed: rowData?.wp_tempate_connected_user_missed || "",
      triggerOnConnected:
        rowData?.trigger_on_connected === "true" ? true : false || false,
      triggerOnMissed:
        rowData?.trigger_on_missed === "true" ? true : false || false,
      isAgentMissed:
        rowData?.trigger_on_connected_agent_missed === "true"
          ? true
          : false || false,
      // isUserMissed:
      //   rowData?.trigger_on_connected_user_missed === "true"
      //     ? true
      //     : false || false,
    },
  ];
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
    setIsSubmit(false);
  };

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    if (!formValues.campaignId) {
      errors.campaignId = "Campaign ID is required!";
    }

    if (!formValues.campaignName) {
      errors.campaignName = "Campaign Name is required!";
    }

    if (!formValues.panelType) {
      errors.panelType = "Panel Type is required!";
    }

    if (!formValues.campaignType) {
      errors.campaignType = "Campaign Type is required!";
    }

    if (formValues.triggerOnConnected === true && !formValues.wpTemConnected) {
      errors.wpTemConnected = "Whatssapp Template Connected Desc Is Required!";
    }

    if (formValues.triggerOnMissed === true && !formValues.wpTemMissed) {
      errors.wpTemMissed = "Whatssapp Template Missed Desc Is Required!";
    }

    if (formValues.isAgentMissed === true && !formValues.agentMissed) {
      errors.agentMissed = "Agent Missed Desc Is Required!";
    }

    // if (formValues.isUserMissed === true && !formValues.userMissed) {
    //   errors.userMissed = "User Missed Desc Is Required!";
    // }

    return errors;
  };

  const handleAdd = async (requestBody) => {
    const method = "POST";
    const endpoint = campaignSystem;
    const payload = requestBody;
    const token = userInfoData?.token || "";

    try {
      const result = rowData?.uid
        ? await dispatch(
            commonUpdate({
              endPoint: campaignSystemUpdate,
              requestBody: payload,
              filters: "",
              TOKEN: token,
            })
          )
        : await dispatch(fetchApiData({ method, endpoint, payload, token }));

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setIsSubmit(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      campaignId: rowData?.campaign_id || "",
      campaignName: rowData?.campaign_name?.replace(/_/g, " ") || "",
      panelType: rowData?.panel_type
        ? {
            value: rowData?.panel_type || "",
            label: rowData?.panel_type === "panel_1" ? "Main(P2P)" : "IVR",
          }
        : "",
      campaignType: rowData?.campaign_type
        ? {
            value: rowData?.campaign_type || "",
            label: rowData?.campaign_type === "1" ? "P2P" : "IVR",
          }
        : "",
      wpTemConnected: rowData?.wp_template_connected || "",
      wpTemMissed: rowData?.wp_template_missed || "",
      agentMissed: rowData?.wp_template_connected_agent_missed || "",
      // userMissed: rowData?.wp_tempate_connected_user_missed || "",
      triggerOnConnected:
        rowData?.trigger_on_connected === "true" ? true : false || false,
      triggerOnMissed:
        rowData?.trigger_on_missed === "true" ? true : false || false,
      isAgentMissed:
        rowData?.trigger_on_connected_agent_missed === "true"
          ? true
          : false || false,
      // isUserMissed:
      //   rowData?.trigger_on_connected_user_missed === "true"
      //     ? true
      //     : false || false,
    }));
  }, [rowData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        campaign_id: formValues.campaignId,
        campaign_name: formValues.campaignName,
        panel_type: formValues.panelType?.value,
        campaign_type: formValues.campaignType?.value,

        wp_template_connected: formValues.wpTemConnected || "",
        wp_template_missed: formValues.wpTemMissed || "",
        wp_template_connected_agent_missed: formValues.agentMissed || "",
        // wp_tempate_connected_user_missed: formValues.userMissed || "",

        trigger_on_connected: formValues.triggerOnConnected ? "true" : "false",
        trigger_on_missed: formValues.triggerOnMissed ? "true" : "false",
        trigger_on_connected_agent_missed: formValues.isAgentMissed
          ? "true"
          : "false",
        // trigger_on_connected_user_missed: formValues.isUserMissed
        //   ? "true"
        //   : "false",
      };

      if (rowData?.uid) {
        userData.uid = rowData.uid;
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(handleConfirm, `Are you sure!`);
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid threeGridSystem">
          <div className="formInputBox">
            <label htmlFor="panelType" className={`formInputLabel `}>
              Panel Type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${formErrors.panelType && "formError"}`}
            >
              <SelectDropdown
                options={panelTypes}
                selectedOption={formValues.panelType}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("panelType", selectedValue)
                }
                name="Panel Type"
              />
            </div>
          </div>

          {formValues.panelType ? (
            <>
              <div className="formInputBox">
                <label htmlFor="campaignId" className={`formInputLabel `}>
                  Campaign ID <span className="required">*</span>
                </label>

                <input
                  type="text"
                  placeholder="Enter Campaign ID"
                  className={`formInput ${
                    formErrors?.campaignId ? "formError" : ""
                  }`}
                  name="campaignId"
                  value={formValues.campaignId}
                  onChange={onChangeInput}
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="campaignName" className={`formInputLabel `}>
                  Campaign Name <span className="required">*</span>
                </label>

                <input
                  type="text"
                  placeholder="Enter Campaign Name"
                  className={`formInput ${
                    formErrors?.campaignName ? "formError" : ""
                  }`}
                  name="campaignName"
                  value={formValues.campaignName}
                  onChange={onChangeInput}
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="campaignType" className={`formInputLabel `}>
                  Campaign Type <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.campaignType && "formError"
                  }`}
                >
                  <SelectDropdown
                    options={campaignTypes}
                    selectedOption={formValues.campaignType}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("campaignType", selectedValue)
                    }
                    name="Campaign Type"
                  />
                </div>

                {/* <input
              type="number"
              placeholder="Enter Campaign Name"
              className={`formInput ${
                formErrors?.campaignType ? "formError" : ""
              }`}
              name="campaignType"
              value={formValues.campaignType}
              onChange={onChangeInput}
            /> */}
              </div>

              <div className="formInputBox span3">
                <label htmlFor="wpTemConnected" className={`formInputLabel `}>
                  Template For Connected
                </label>

                <div className="double-input text-n-check">
                  <input
                    type="text"
                    placeholder="Enter Connected Template Name"
                    className={`formInput ${
                      formErrors?.wpTemConnected ? "formError" : ""
                    }`}
                    name="wpTemConnected"
                    value={formValues.wpTemConnected?.replace(/_/g, " ")}
                    onChange={onChangeInput}
                  />

                  <Form.Check
                    type="switch"
                    name="triggerOnConnected"
                    className={`${
                      formErrors?.triggerOnConnected ? "formError" : ""
                    }`}
                    label={`${
                      formValues.triggerOnConnected
                        ? "Trigger On Connect"
                        : "No Trigger On Connect"
                    }`}
                    checked={formValues.triggerOnConnected}
                    onChange={onChangeInput}
                  />
                </div>
              </div>

              <div className="formInputBox span3">
                <label htmlFor="wpTemMissed" className={`formInputLabel `}>
                  Template For Missed
                </label>

                <div className="double-input text-n-check">
                  <input
                    type="text"
                    placeholder="Enter Missed Template Name"
                    className={`formInput ${
                      formErrors?.wpTemMissed ? "formError" : ""
                    }`}
                    name="wpTemMissed"
                    value={formValues.wpTemMissed?.replace(/_/g, " ")}
                    onChange={onChangeInput}
                  />

                  <Form.Check
                    type="switch"
                    name="triggerOnMissed"
                    className={`${
                      formErrors?.triggerOnMissed ? "formError" : ""
                    }`}
                    label={`${
                      formValues.triggerOnMissed
                        ? "Trigger On Missed"
                        : "No Trigger On Missed"
                    }`}
                    checked={formValues.triggerOnMissed}
                    onChange={onChangeInput}
                  />
                </div>
              </div>

              {formValues.campaignType?.value === "2" ? (
                <div className="formInputBox span3">
                  <label htmlFor="agentMissed" className={`formInputLabel `}>
                    Template For Agent Missed
                  </label>

                  <div className="double-input text-n-check">
                    <input
                      type="text"
                      placeholder="Enter Template Name For Agent Missed"
                      className={`formInput ${
                        formErrors?.agentMissed ? "formError" : ""
                      }`}
                      name="agentMissed"
                      value={formValues.agentMissed?.replace(/_/g, " ")}
                      onChange={onChangeInput}
                    />

                    <Form.Check
                      type="switch"
                      name="isAgentMissed"
                      className={`${
                        formErrors?.isAgentMissed ? "formError" : ""
                      }`}
                      label={`${
                        formValues.isAgentMissed
                          ? "Agent Missed Template"
                          : "No Template For Agent Missed"
                      }`}
                      checked={formValues.isAgentMissed}
                      onChange={onChangeInput}
                    />
                  </div>
                </div>
              ) : // :
              // formValues.campaignType?.value === "1" ? (
              //   <div className="formInputBox span3">
              //     <label htmlFor="userMissed" className={`formInputLabel `}>
              //       Template For User Missed
              //     </label>

              //     <div className="double-input text-n-check">
              //       <input
              //         type="text"
              //         placeholder="Enter Template Name For User Missed"
              //         className={`formInput ${
              //           formErrors?.userMissed ? "formError" : ""
              //         }`}
              //         name="userMissed"
              //         value={formValues.userMissed?.replace(/_/g, " ")}
              //         onChange={onChangeInput}
              //       />

              //       <Form.Check
              //         type="switch"
              //         name="isUserMissed"
              //         className={`${
              //           formErrors?.isUserMissed ? "formError" : ""
              //         }`}
              //         label={`${
              //           formValues.isUserMissed
              //             ? "User Missed Template"
              //             : "No Template For User Missed"
              //         }`}
              //         checked={formValues.isUserMissed}
              //         onChange={onChangeInput}
              //       />
              //     </div>
              //   </div>
              // )
              null}
            </>
          ) : null}
        </div>

        <CloseSubmitBtn
          closeLabel="Back"
          submitLabel={rowData && rowData?.uid ? "Update" : "Submit"}
          onClose={closeModal}
          onSubmit={onSumitForm}
          isLoading={loading}
        />

        {/* <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          <Button className="saveBtn" variant="danger" onClick={onSumitForm}>
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <>{rowData && rowData?.uid ? "Edit" : "Submit"}</>
            )}
          </Button>
        </div> */}
      </form>
    </div>
  );
};

export default CampaignForm;
